@if (startLoader) {
<div class="loader-overlay">
  <div class="backdrop"></div>
  <ap-loading class="loader" [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
</div>
}
<dst-create-disclosure-actions [isView]="false" (onSaveClick)="save()" [disabled]="false" [displayNotification]="showDREMsg" [notifMsg]="DREMsg"
                               (onCancelClick)="clear()">
</dst-create-disclosure-actions>
<div class="form-template-wrapper" [ngClass]="showDREMsg ? 'msg-expanded' : ''">
  <div [formGroup]="form215" class="ap-form-field-my-wrapper">
    <dst-template-header [parentFormGroup]="form215" (formOptionChanged)="onFormOptionChanged($event)"
                         (consolGroupChanged)="OnConsolGroupChanged($event)">
    </dst-template-header>
    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
      <tr>
        <td class="header-text">
          <strong>&nbsp;&nbsp;Part I &nbsp;&nbsp;</strong>
          <strong>Filer's Identifying Information</strong>
        </td>
      </tr>
      </tbody>
    </table>
    <div formGroupName="partOne" class="section-content ap-form-field-my-wrapper">
      <ol class="section-content mb-0">
        <li>
          <ol class="inner-list">
            <li>
              <dst-template-leid-selector class="required-field" [label]="'Please specify the LEID of the Filer'" [labelId]="'100'"
                                          (onSelectedLEChanged)="onTransferorChanged($event)">
              </dst-template-leid-selector>
              <div class="entity-details">
                <span>Name of Filer:</span><span class="template-color-blue">{{!transferor ? '' :
                                                                               transferor.ENTITY}}</span>
              </div>
            </li>
            <li>
              <div class="entity-details">
                <span>Identifying number:</span><span class="template-color-blue">{{!transferor ? '' :
                                                                                    (transferor.EIN ? transferor.EIN : 'N/A')}}</span>
              </div>
            </li>
            <br/>
            <li>
              <div class="d-flex">
                <div class="col-md-4 align-field-text">
                  Check applicable box
                </div>
                <div class="col-md-7 p-0">
                  <ap-radio-group [ariaLabel]="'Check applicable box'">
                  <ap-radio [value]="$any(true)" [name]="'radio-group-1'" [(ngModel)]="Choice1cTarget" [ngModelOptions]="{standalone: true}"
                            (onChange)="check1c(true)" [styleClass]="'a-mx-10 required-field-radio'" [style]="'margin-left: 0px !important;'">
                    <span>Old target</span>
                  </ap-radio>
                  <ap-radio [value]="$any(false)" [name]="'radio-group-1'" [(ngModel)]="Choice1cTarget" [ngModelOptions]="{standalone: true}"
                            (onChange)="check1c(false)" [styleClass]="'a-mx-10 required-field-radio'">
                    <span>New target</span>
                  </ap-radio>
                </ap-radio-group>
                </div>
              </div>
            </li>
            <br/>
            <li>
              <div class="d-flex">
                <div class="col-md-4 align-field-text">
                  Was a valid and timely Form 8023 filed?
                </div>
                <div class="col-md-7 p-0">
                  <ap-radio-group [ariaLabel]="'Was a valid and timely Form 8023 filed?'">
                  <ap-radio [value]="$any(true)" [name]="'radio-group-2'" [(ngModel)]="Choice1dDate" [ngModelOptions]="{standalone: true}"
                            (onChange)="check1d(true)" [styleClass]="'a-mx-10 required-field-radio'" [style]="'margin-left: 0px !important;'">
                    <span>Yes</span>
                  </ap-radio>
                  <ap-radio [value]="$any(false)" [name]="'radio-group-2'" [(ngModel)]="Choice1dDate" [ngModelOptions]="{standalone: true}"
                            (onChange)="check1d(false)" [styleClass]="'a-mx-10 required-field-radio'">
                    <span>No</span>
                  </ap-radio>
                </ap-radio-group>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div class="col-md-4 align-field-text">
                  If yes, enter date filed.
                </div>
                <div class="col-md-7 p-0">
                  @if (nameChangeChecked) {
<app-date-picker-with-clear
                   
                    [hidden]="Choice1dDate !== true"
                    [minDate]="beginDate"
                    [maxDate]="endDate"
                    [datePickerClass]="'required-field'"
                    [required]="true"
                    (dateChange)="dateChange($event, 1)"
                    (datePickerClick)="onDPOpen()"
                    (clearClick)="clearDate(1)"
                    [(ngModel)]="Yes1dDateText"
                    [ngModelOptions]="{standalone: true}">
                  </app-date-picker-with-clear>
}
                </div>
              </div>

            </li>
          </ol>
        </li>
      </ol>

    </div>
    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
      <tr>
        <td class="header-text">
          <strong>&nbsp;&nbsp;Part II &nbsp;&nbsp; Other Party's Identifying Information</strong>
        </td>
      </tr>
      </tbody>
    </table>
    <div formGroupName="partTwo" class="section-content ap-form-field-my-wrapper">
      <div class="d-flex">
        <div class="col-md-4">
          Is the Other Party a US Entity ?
        </div>
        <div class="col-md-3 pl-0">
          <ap-radio-group [ariaLabel]="'Is the Other Party a US Entity ?'">
                  <ap-radio [value]="$any(true)" [name]="'radio-group-3'" [(ngModel)]="OtherPartyUSEnt" [ngModelOptions]="{standalone: true}" (onChange)="check2(true)"
                    [styleClass]="'a-mx-10 required-field-radio'">
            <span>Yes</span>
          </ap-radio>
                  <ap-radio [value]="$any(false)" [name]="'radio-group-3'" [(ngModel)]="OtherPartyUSEnt" [ngModelOptions]="{standalone: true}" (onChange)="check2(false)"
                    [styleClass]="'a-mx-10 required-field-radio'">
            <span>No</span>
          </ap-radio>
                </ap-radio-group>
        </div>
      </div>
      <br/>
      <ol class="section-content" start="2" [hidden]="OtherPartyUSEnt === undefined">
        <li>
          <ol class="inner-list">
            <li>
              <div class="part-two d-flex">
                <div class="col-md-4">
                  Name of other party to the transaction
                </div>
                <div class="col-md-8 radio-align">
                  <ap-field [title]="''" [fieldId]="'1'" [styleClass]="'required-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="OtherParty" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="1" />
                  </ap-field>
                </div>
              </div>
            </li>
            <li>
              <div class="part-two d-flex">
                <div class="col-md-4">
                  EIN
                </div>
                <div class="col-md-3 radio-align mt-1">
                  <ap-radio-group [ariaLabel]="'EIN'">
                  <ap-radio [value]="$any(true)" [name]="'radio-group-4'" [(ngModel)]="einSsnRadio" [ngModelOptions]="{standalone: true}"
                            (onChange)="check2b(true)" [styleClass]="'a-mx-10'">
                    <span>EIN or</span>
                  </ap-radio>
                  <ap-radio [value]="$any(false)" [name]="'radio-group-4'" [(ngModel)]="einSsnRadio" [ngModelOptions]="{standalone: true}"
                            (onChange)="check2b(false)" [styleClass]="'a-mx-10'">
                    <span>SSN?</span>
                  </ap-radio>
                </ap-radio-group>
                </div>
              </div>
              <div class="part-two d-flex mt-1">
                <div class="col-md-4">
                </div>
                @if (OtherPartyUSEnt) {
<div class="col-md-3 radio-align">
                  <!-- <ap-form-field [hidden]="einSsnRadio !== true" [inlineBlock]="true" [label]="''"
                                 formControlName="EINAppOP" [(ngModel)]="EINAppOP" class="required-field" [id]="'2'" [type]="'input'" [placeholder]="''">
                  </ap-form-field>   -->
                  <dst-custom-input class="required-field dst-field" [hidden]="einSsnRadio !== true" [type]="'inputNumber'" id="2" [label]="''" [maxLength]="9" [value]="EINAppOP" (valChange)="EINAppOP = $event;"></dst-custom-input>
                  <ap-field [hidden]="einSsnRadio !== false" [title]="''" [fieldId]="'3'" [styleClass]="'required-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="SNAppOP" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="3" />
                  </ap-field>
                </div>
}
                @if (!OtherPartyUSEnt) {
<div class="col-md-3 radio-align">
                  <ap-field [hidden]="einSsnRadio !== true" [title]="''" [fieldId]="'2'" [styleClass]="'required-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="EINAppOP" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="2" />
                  </ap-field>
                  <!-- <dst-custom-input [hidden]="einSsnRadio !== true && OtherPartyUSEnt === true" [type]="'inputNumber'" id="2" [label]="''" [maxLength]="9" [value]="EINAppOP" (valChange)="EINAppOP = $event;"></dst-custom-input> -->
                  <ap-field [hidden]="einSsnRadio !== false" [title]="''" [fieldId]="'3'" [styleClass]="'required-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="SNAppOP" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="3" />
                  </ap-field>
                </div>
}
              </div>
            </li>
            <li class="mt-3">
              @if ((!EINAppOP && einSsnRadio) || (!SNAppOP && !einSsnRadio) ) {
<div class="part-two d-flex">
                <div class="col-md-4">
                  EIN Missing Reason:
                </div>
                <div class="col-md-3 radio-align">
                  <ap-dropdown [list]="EINMissingReason1" [selectType]="'single'"
                               [(ngModel)]="selectedEINMissing1Item" [ngModelOptions]="{standalone: true}"
                               [title]="'** Please select the missing reason **'" [inputAriaLabel]="'** Please select the missing reason **'" [hideTitleOnInput]="true"
                               (onSelect)="missingReason1($event)" class="">
                    @for (item of EINMissingReason1; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                      [ariaLabel]="setAriaLabel(item, '** Please select the missing reason **')"
                      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                  </ap-dropdown>
                </div>
              </div>
}

              <br/>
              <div class="part-two d-flex">
                <div class="col-md-4">
                  Address Line 1
                </div>
                <div class="col-md-8 radio-align">
                  <ap-field [title]="''" [fieldId]="'4'" [styleClass]="'required-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="AddressOfOtherParty1" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="4" />
                  </ap-field>
                </div>
              </div>
              <br/>
              <div class="part-two d-flex">
                <div class="col-md-4">
                  Address Line 2
                </div>
                <div class="col-md-8 radio-align">
                  <ap-field [title]="''" [fieldId]="'5'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="AddressOfOtherParty2" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="5" />
                  </ap-field>
                </div>
              </div>
              <br/>
              <div class="part-two d-flex">
                <div class="col-md-4">
                  City
                </div>
                <div class="col-md-8 radio-align">
                  <ap-field [title]="''" [fieldId]="'6'" [styleClass]="'required-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="CityOfOtherParty" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="6" />
                  </ap-field>
                </div>
              </div>
              <br/>
              @if (OtherPartyUSEnt) {
<div class="part-two d-flex">
                <div class="col-md-4">
                  State
                </div>
                <div class="col-md-8 radio-align">
                  <ap-dropdown #stateDropdown [list]="StateOptions" [selectType]="'single'" [showSearchbox]="true" class="field-full-width"
                               [(ngModel)]="selectedStateItem" [ngModelOptions]="{standalone: true}"
                               [title]="'** Please select a state name **'" [inputAriaLabel]="'** Please select a state name **'" [hideTitleOnInput]="true"
                               (onSelect)="stateChange($event)">
                    @for (item of StateOptions; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                      [ariaLabel]="setAriaLabel(item, '** Please select a state name **')"
                      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                  </ap-dropdown>
                </div>
              </div>
}
              @if (OtherPartyUSEnt) {
<br/>
}
              @if (OtherPartyUSEnt === false) {
<div class="part-two d-flex">
                <div class="col-md-4">
                  Province or State
                </div>
                <div class="col-md-3 radio-align">
                  <ap-field [title]="''" [fieldId]="'7'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="ProvOrStateOP" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="7" />
                  </ap-field>
                </div>
              </div>
}
              @if (OtherPartyUSEnt === false) {
<br/>
}
              @if (OtherPartyUSEnt === false) {
<div class="part-two d-flex">
                <div class="col-md-4">
                  Country
                </div>
                <div class="col-md-8 radio-align">
                  <ap-dropdown class="field-full-width" [list]="CountryOptions" [selectType]="'single'"
                               [(ngModel)]="selectedCountryItem" [ngModelOptions]="{standalone: true}"
                               [showSearchbox]="true" [title]="'** Select Country **'" [inputAriaLabel]="'** Select Country **'" [hideTitleOnInput]="true"
                               (onSelect)="countryChange($event)">
                    @for (item of CountryOptions; track item.value) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                      [ariaLabel]="setAriaLabel(item, '** Select Country **')"
                      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                  </ap-dropdown>
                </div>
              </div>
}
              @if (OtherPartyUSEnt === false) {
<br/>
}
              <div class="part-two d-flex">
                <div class="col-md-4">
                  Zip Code
                </div>
                <div class="col-md-3 radio-align">
                  <ap-field [title]="''" [fieldId]="'8'" [styleClass]="'required-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="ZIPCodeOfOtherParty" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="8" />
                  </ap-field>
                </div>
              </div>
              <br/>
            </li>
          </ol>
        </li>
      </ol>
    </div>
    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
      <tr>
        <td class="header-text">
          <strong>&nbsp;&nbsp;Part III &nbsp;&nbsp; Target Corporation's Identifying Information</strong>
        </td>
      </tr>
      </tbody>
    </table>
    <div formGroupName="partThree" class="section-content ap-form-field-my-wrapper">
      <div class="d-flex">
        <div class="col-md-4">
          Is the Target a US Entity?
        </div>
        <div class="col-md-2 pl-0">
          <ap-radio-group [ariaLabel]="'Is the Target a US Entity?'">
                  <ap-radio [value]="$any(true)" [name]="'radio-group-5'" [(ngModel)]="TargetCorpUSEnt" [ngModelOptions]="{standalone: true}" (onChange)="check3(true)"
                    [styleClass]="'a-mx-10 required-field-radio'">
            <span>Yes</span>
          </ap-radio>
                  <ap-radio [value]="$any(false)" [name]="'radio-group-5'" [(ngModel)]="TargetCorpUSEnt" [ngModelOptions]="{standalone: true}" (onChange)="check3(false)"
                    [styleClass]="'a-mx-10 required-field-radio'">
            <span>No</span>
          </ap-radio>
                </ap-radio-group>
        </div>
      </div>
      <ol class="section-content" start="3" [hidden]="TargetCorpUSEnt === undefined">
        <li>
          <ol class="inner-list">
            <li>
              <dst-template-leid-selector #targetLeidComp [label]="'Please specify the LEID of the target corporation'"
                                          [labelId]="'100'" class="required-field" (onSelectedLEChanged)="onTransfereeChanged($event)">
              </dst-template-leid-selector>
              <div class="entity-details">
                <span>Name of Target Corporation:</span><span class="template-color-blue">{{!transferee ? '' : transferee.ENTITY}}</span>
              </div>
            </li>
            <li>
              <div class="entity-details">
                <span>Employer identification number:</span><span class="template-color-blue">{{!transferee ? '' : (transferee.EIN ? transferee.EIN : 'N/A')}}</span>
              </div>
              @if (transferee && !transferee.EIN) {
<div class="entity-details">
                <span> EIN Missing Reason: </span>
                <div class="col-md-3 pl-0">
                  <ap-dropdown [list]="EINMissingReason" [selectType]="'single'"
                    [(ngModel)]="selectedEINMissingItem" [ngModelOptions]="{standalone: true}"
                    [title]="'** Please select the missing reason **'" [inputAriaLabel]="'** Please select the missing reason **'" [hideTitleOnInput]="true"
                    (onSelect)="missingReason($event)" class="">
                    @for (item of EINMissingReason; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                      [ariaLabel]="setAriaLabel(item, '** Please select the missing reason **')"
                      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                  </ap-dropdown>
                </div>
              </div>
}
            </li>
            <li>
              <div class="entity-details">
                <span>Address Line 1:</span><span class="template-color-blue">{{!transferee ? '' : transferee.ADDRESS1}}</span>
              </div>
              <div class="entity-details">
                <span>Address Line 2:</span><span class="template-color-blue">{{!transferee ? '' : transferee.ADDRESS2 }}</span>
              </div>
              <div class="entity-details">
                @if (TargetCorpUSEnt === true) {
<span>State:</span>
}@if (TargetCorpUSEnt === false) {
<span>Province or
                  State:</span>
}<span class="template-color-blue">{{!transferee ? '' : stateNamePart3 }}</span>
              </div>
              <div class="entity-details">
                <span>City / Town:</span><span class="template-color-blue">{{!transferee ? '' : transferee.CITY}}</span>
              </div>
              <div class="entity-details">
                <span>Country:</span><span class="template-color-blue">{{!transferee ? '' : transferee.COUNTRYNAME}}</span>
              </div>
              <div class="entity-details">
                @if (TargetCorpUSEnt === true) {
<span>Zip Code:</span>
}@if (TargetCorpUSEnt === false) {
<span>Postal
                  Code:</span>
}<span class="template-color-blue">{{!transferee ? '' : transferee.ZIP}}</span>
              </div>
              <div class="entity-details">
                <span>State of Incorportation:</span><span class="template-color-blue">{{!transferee ? '' : transferee.STATEINC}}</span>
              </div>
              <div class="entity-details">
                <span>Country of Incorporation:</span><span class="template-color-blue">{{!transferee ? '' : transferee.COUNTRYINC}}</span>
              </div>
            </li>
          </ol>
        </li>
      </ol>
      <br/>
    </div>
    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
      <tr>
        <td class="header-text">
          <strong>&nbsp;&nbsp;Part IV</strong>
          &nbsp;&nbsp;
          <strong>General Information</strong>
        </td>
      </tr>
      </tbody>
    </table>
    <div formGroupName="partFour" class="section-content ap-form-field-my-wrapper">
      <ol class="section-content" start="4">
        <li>
          <ol class="inner-list">
            <li>
              <div class="d-flex">
                <div class="col-md-8">
                  Acquisition Date
                </div>
                <div class="col-md-4 align-date">
                  <app-date-picker-with-clear
                    [minDate]="beginDate"
                    [maxDate]="endDate"
                    [datePickerClass]="'required-field acqt-date'"
                    [required]="true"
                    (dateChange)="dateChange($event, 2)"
                    (datePickerClick)="onDPOpen()"
                    (clearClick)="clearDate(2)"
                    [(ngModel)]="AcquisionDate"
                    [ngModelOptions]="{standalone: true}">
                  </app-date-picker-with-clear>
                </div>
              </div>
            </li>
            <li>What percentage of target corporation stock was purchased:
              <ol class="third-list">
                <li>
                  <div class="d-flex">
                    <div class="col-md-8">
                      During the 12-month acquisition period
                    </div>
                    <div class="col-md-4 d-flex part-two part-two--fixed-number-field">
                      <gtw-nullable-number-input
                        [inlineBlock]="true"
                        [label]="''"
                        [id]="'9'"
                        [minNum]="0"
                        [maxNum]="100"
                        [placeholder]="''"
                        class="number-field required-field"
                        [(ngModel)]="PctDuring12Month"
                        [ngModelOptions]="{standalone: true}">
                      </gtw-nullable-number-input><span class="currency-suffix">%</span>
                    </div>
                  </div>
                </li>
                <br/>
                <li>
                  <div class="d-flex">
                    <div class="col-md-8">
                      On the acquisition date
                    </div>
                    <div class="col-md-4 d-flex part-two part-two--fixed-number-field">
                      <gtw-nullable-number-input
                        [inlineBlock]="true"
                        [label]="''"
                        [id]="'10'"
                        [minNum]="0"
                        [maxNum]="100"
                        [placeholder]="''"
                        class="number-field required-field"
                        [(ngModel)]="PctOnAcquisition"
                        [ngModelOptions]="{standalone: true}">
                      </gtw-nullable-number-input><span class="currency-suffix">%</span>
                    </div>
                  </div>
                </li>
                <br/>
              </ol>
            </li>
          </ol>
        </li>
        <li>
          <ol class="inner-list">
            <li>
              <div class="d-flex">
                <div class="col-md-8">
                  Stock price
                </div>
                <div class="col-md-4 d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'11'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field required-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="StockPrice" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="11" />
                  </ap-field>

                </div>
              </div>
            </li>
            <br/>
            <li>
              <div class="d-flex">
                <div class="col-md-8">
                  Acquisition costs/Selling costs
                </div>
                <div class="col-md-4 d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'12'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field required-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="AcquisitionCostSC" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="12" />
                  </ap-field>

                </div>
              </div>
            </li>
            <br/>
            <li>
              <div class="d-flex">
                <div class="col-md-8">
                  Target liabilities
                </div>
                <div class="col-md-4 d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'13'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field required-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="TargetLiabilities" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="13" />
                  </ap-field>

                </div>
              </div>
            </li>
            <br/>
            <li>
              <div class="d-flex">
                <div class="col-md-8">
                  AGUB/ADSP
                </div>
                <div class="col-md-4 d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'14'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field required-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="AGUBorADSP" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="14" />
                  </ap-field>

                </div>
              </div>
            </li>
            <br/>
          </ol>
        </li>
        <br/>
        <li>
          <div class="d-flex">
            <div class="col-md-8">
              Was the filer listed in Part I, above a member of an affiliated group of corporation before the
              acquisition date?
            </div>
            <div class="col-md-4">
              <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" [name]="'radio-group-6'" [(ngModel)]="Choice6" [ngModelOptions]="{standalone: true}"
                        (onChange)="check6(true)" [styleClass]="'a-mx-10 align-radio required-field-radio'">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" [name]="'radio-group-6'" [(ngModel)]="Choice6" [ngModelOptions]="{standalone: true}"
                        (onChange)="check6(false)" [styleClass]="'a-mx-10 required-field-radio'">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
            </div>
          </div>
        </li>
        <br/>

        <li>
          <div class="d-flex">
            <div class="col-md-8">
              Was the target corporation a member of an affiliated group before the acquisition date?
            </div>
            <div class="col-md-4">
              <ap-radio-group [ariaLabel]="'Was the target corporation a member of an affiliated group before the acquisition date?'">
                  <ap-radio [value]="$any(true)" [name]="'radio-group-7'" [(ngModel)]="Choice7" [ngModelOptions]="{standalone: true}"
                        (onChange)="check7(true)" [styleClass]="'a-mx-10 align-radio required-field-radio'">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" [name]="'radio-group-7'" [(ngModel)]="Choice7" [ngModelOptions]="{standalone: true}"
                        (onChange)="check7(false)" [styleClass]="'a-mx-10 required-field-radio'">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
            </div>
          </div>
        </li>
        <br/>
        <li>Is the target corporation or any target affiliate:
          <ol class="inner-list section-content">
            <li>
              <div class="d-flex">
                <div class="col-md-8">
                  A controlled foreign corporation?
                </div>
                <div class="col-md-4 pl-4">
                  <ap-radio-group [ariaLabel]="'A controlled foreign corporation?'">
                  <ap-radio [value]="$any(true)" [name]="'radio-group-8'" [(ngModel)]="Choice8a" [ngModelOptions]="{standalone: true}"
                            (onChange)="check8a(true)" [styleClass]="'a-mx-10 required-field-radio'">
                    <span>Yes</span>
                  </ap-radio>
                  <ap-radio [value]="$any(false)" [name]="'radio-group-8'" [(ngModel)]="Choice8a" [ngModelOptions]="{standalone: true}"
                            (onChange)="check8a(false)" [styleClass]="'a-mx-10 required-field-radio'">
                    <span>No</span>
                  </ap-radio>
                </ap-radio-group>
                </div>
              </div>
              <br/>
              <div class="d-flex">
                <div class="col-md-8">
                  If "No", check here if it was a CFC at any time during the preceding 5 years
                </div>
                <div class="col-md-4 pl-4">
                  <ap-checkbox [ngModel]="editMode && IsCFCPrev5Yrs ? true : false" [ngModelOptions]="{standalone: true}"
                               (onChange)="check8abox($event)" [styleClass]="'a-mx-10'">
                    <span></span>
                  </ap-checkbox>
                </div>
              </div>

            </li>
            <br/>
            <li>
              <div class="d-flex">
                <div class="col-md-8">
                  A foreign corporation with income, gain, or loss effectively connected with the conduct of a trade or
                  business within the United States (including U.S. real property interests)?
                </div>
                <div class="col-md-4 pl-4">
                  <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" [name]="'radio-group-9'" [(ngModel)]="Choice8b" [ngModelOptions]="{standalone: true}"
                            (onChange)="check8b(true)" [styleClass]="'a-mx-10 required-field-radio'">
                    <span>Yes</span>
                  </ap-radio>
                  <ap-radio [value]="$any(false)" [name]="'radio-group-9'" [(ngModel)]="Choice8b" [ngModelOptions]="{standalone: true}"
                            (onChange)="check8b(false)" [styleClass]="'a-mx-10 required-field-radio'">
                    <span>No</span>
                  </ap-radio>
                </ap-radio-group>
                </div>
              </div>
            </li>
            <br/>
            <li>
              <div class="d-flex">
                <div class="col-md-8">
                  A qualifying foreign target under Regulations section 1.338-2(e)(1)(iii)
                </div>
                <div class="col-md-4 pl-4">
                  <ap-radio-group [ariaLabel]="'A qualifying foreign target under Regulations section 1.338-2(e)(1)(iii)'">
                  <ap-radio [value]="$any(true)" [name]="'radio-group-10'" [(ngModel)]="Choice8c" [ngModelOptions]="{standalone: true}"
                            (onChange)="check8c(true)" [styleClass]="'a-mx-10 required-field-radio'">
                    <span>Yes</span>
                  </ap-radio>
                  <ap-radio [value]="$any(false)" [name]="'radio-group-10'" [(ngModel)]="Choice8c" [ngModelOptions]="{standalone: true}"
                            (onChange)="check8c(false)" [styleClass]="'a-mx-10 required-field-radio'">
                    <span>No</span>
                  </ap-radio>
                </ap-radio-group>
                </div>
              </div>
            </li>
            <br/>
            <li>
              <div class="d-flex">
                <div class="col-md-8">
                  A corporation electing under section 1504(d) or section 953(d)?
                </div>
                <div class="col-md-4 pl-4">
                  <ap-radio-group [ariaLabel]="'A corporation electing under section 1504(d) or section 953(d)?'">
                  <ap-radio [value]="$any(true)" [name]="'radio-group-11'" [(ngModel)]="Choice8e" [ngModelOptions]="{standalone: true}"
                            (onChange)="check8e(true)" [styleClass]="'a-mx-10 required-field-radio'">
                    <span>Yes</span>
                  </ap-radio>
                  <ap-radio [value]="$any(false)" [name]="'radio-group-11'" [(ngModel)]="Choice8e" [ngModelOptions]="{standalone: true}"
                            (onChange)="check8e(false)" [styleClass]="'a-mx-10 required-field-radio'">
                    <span>No</span>
                  </ap-radio>
                </ap-radio-group>
                </div>
              </div>
            </li>
            <br/>
            <li>
              <div class="d-flex">
                <div class="col-md-8">
                  A domestic international sales corporation (DISC)?
                </div>
                <div class="col-md-4 pl-4">
                  <ap-radio-group [ariaLabel]="'A domestic international sales corporation (DISC)?'">
                  <ap-radio [value]="$any(true)" [name]="'radio-group-12'" [(ngModel)]="Choice8f" [ngModelOptions]="{standalone: true}"
                            (onChange)="check8f(true)" [styleClass]="'a-mx-10 required-field-radio'">
                    <span>Yes</span>
                  </ap-radio>
                  <ap-radio [value]="$any(false)" [name]="'radio-group-12'" [(ngModel)]="Choice8f" [ngModelOptions]="{standalone: true}"
                            (onChange)="check8f(false)" [styleClass]="'a-mx-10 required-field-radio'">
                    <span>No</span>
                  </ap-radio>
                </ap-radio-group>
                </div>
              </div>
            </li>
            <br/>
            <li>
              <div class="d-flex">
                <div class="col-md-8">
                  A passive foreign investment company (PFIC)?
                </div>
                <div class="col-md-4 pl-4">
                  <ap-radio-group [ariaLabel]="'A passive foreign investment company (PFIC)?'">
                  <ap-radio [value]="$any(true)" [name]="'radio-group-13'" [(ngModel)]="Choice8g" [ngModelOptions]="{standalone: true}"
                            (onChange)="check8g(true)" [styleClass]="'a-mx-10 required-field-radio'">
                    <span>Yes</span>
                  </ap-radio>
                  <ap-radio [value]="$any(false)" [name]="'radio-group-13'" [(ngModel)]="Choice8g" [ngModelOptions]="{standalone: true}"
                            (onChange)="check8g(false)" [styleClass]="'a-mx-10 required-field-radio'">
                    <span>No</span>
                  </ap-radio>
                </ap-radio-group>
                </div>
              </div>
            </li>
            <br/>
            <li [hidden]="Choice8g !== true">
              <div class="d-flex">
                <div class="col-md-8">
                  If the answer to item 8f is "Yes", is the PFIC a pedigreed qualified electing fund?
                </div>
                <div class="col-md-4 pl-4">
                  <ap-radio-group [ariaLabel]="'If the answer to item 8f is \'Yes\', is the PFIC a pedigreed qualified electing fund?'">
                  <ap-radio [value]="$any(true)" [name]="'radio-group-14'" [(ngModel)]="Choice8h" [ngModelOptions]="{standalone: true}"
                            (onChange)="check8h(true)" [styleClass]="'a-mx-10 required-field-radio'">
                    <span>Yes</span>
                  </ap-radio>
                  <ap-radio [value]="$any(false)" [name]="'radio-group-14'" [(ngModel)]="Choice8h" [ngModelOptions]="{standalone: true}"
                            (onChange)="check8h(false)" [styleClass]="'a-mx-10 required-field-radio'">
                    <span>No</span>
                  </ap-radio>
                </ap-radio-group>
                </div>
              </div>
            </li>
            <br/>
          </ol>
        </li>
      </ol>
    </div>
    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
      <tr>
        <td class="header-text">
          <strong>&nbsp;&nbsp;Part V</strong>
          &nbsp;&nbsp;
          <strong>Original Statement of Assets Transferred</strong>
        </td>
      </tr>
      </tbody>
    </table>
    <div formGroupName="partFive" class="section-content ap-form-field-my-wrapper">
      <ol class="section-content list-content" start="9">
        <li style="counter-reset: count 8;">
          <table class="table-layout w-100 part5-table">
            <thead>
            <tr>
              <td class="col-md-4">
                Assets
              </td>
              <td class="col-md-4">
                Aggregate fair market value<br/>
                (actual amount for Class I)<br/>
                (For e-filing purposes, must be in USD)
              </td>
              <td class="col-md-4">
                Allocation of AGUB or ADSP<br/>
                (For e-filing purposes, must be in USD)
              </td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="col-md-4 row-label">
                Class I
              </td>
              <td class="col-md-4 pr-0">
                <div class="d-flex part-two">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'15'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-70'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class1AFMV" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue({value: $event}, 1)"  aria-label="15" />
                  </ap-field>
                </div>
              </td>
              <td class="col-md-4 pl-0">
                <div class="d-flex part-two">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'16'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-70'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class1AGUBOrADSP" [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="updateValue({value: $event}, 7)" [placeholder]="''"  aria-label="16" />
                  </ap-field>
                </div>

              </td>
            </tr>
            <tr>
              <td class="col-md-4 row-label">
                Class II
              </td>
              <td class="col-md-4 pr-0">
                <div class="d-flex part-two">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'17'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-70'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class2AFMV" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue({value: $event}, 2)"  aria-label="17" />
                  </ap-field>
                </div>
              </td>
              <td class="col-md-4 pl-0">
                <div class="d-flex part-two">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'18'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-70'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class2AGUBOrADSP" [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="updateValue({value: $event}, 8)" [placeholder]="''"  aria-label="18" />
                  </ap-field>
                </div>

              </td>
            </tr>
            <tr>
              <td class="col-md-4 row-label">
                Class III
              </td>
              <td class="col-md-4 pr-0">
                <div class="d-flex part-two">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'19'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-70'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class3AFMV" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue({value: $event}, 3)"  aria-label="19" />
                  </ap-field>
                </div>
              </td>
              <td class="col-md-4 pl-0">
                <div class="d-flex part-two">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'20'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-70'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class3AGUBOrADSP" [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="updateValue({value: $event}, 9)" [placeholder]="''"  aria-label="20" />
                  </ap-field>
                </div>

              </td>
            </tr>
            <tr>
              <td class="col-md-4 row-label">
                Class IV
              </td>
              <td class="col-md-4 pr-0">
                <div class="d-flex part-two">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'21'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-70'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class4AFMV" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue({value: $event}, 4)"  aria-label="21" />
                  </ap-field>
                </div>
              </td>
              <td class="col-md-4 pl-0">
                <div class="d-flex part-two">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'22'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-70'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class4AGUBOrADSP" [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="updateValue({value: $event}, 10)" [placeholder]="''"  aria-label="22" />
                  </ap-field>
                </div>

              </td>
            </tr>
            <tr>
              <td class="col-md-4 row-label">
                Class V
              </td>
              <td class="col-md-4 pr-0">
                <div class="d-flex part-two">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'23'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-70'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class5AFMV" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue({value: $event}, 5)"  aria-label="23" />
                  </ap-field>
                </div>
              </td>
              <td class="col-md-4 pl-0">
                <div class="d-flex part-two">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'24'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-70'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class5AGUBOrADSP" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue({value: $event}, 11)"  aria-label="24" />
                  </ap-field>
                </div>

              </td>
            </tr>
            <tr>
              <td class="col-md-4 row-label">
                Class VI and VII
              </td>
              <td class="col-md-4 pr-0">
                <div class="d-flex part-two">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'25'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-70'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class6N7AFMV" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue({value: $event}, 6)"  aria-label="25" />
                  </ap-field>
                </div>
              </td>
              <td class="col-md-4 pl-0">
                <div class="d-flex part-two">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'26'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-70'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class6N7AGUBOrADSP" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue({value: $event}, 12)"  aria-label="26" />
                  </ap-field>
                </div>

              </td>
            </tr>
            <tr>
              <td class="col-md-4 row-label">
                Total
              </td>
              <td class="col-md-4 pr-0">
                <div class="d-flex part-two">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'27'" [type]="'appkit-number'" [format]="''" [disabled]="true"
                    [styleClass]="'number-field w-70 total-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="TotalAFMV" [ngModelOptions]="{standalone: true}" [placeholder]="'0'"  aria-label="27" />
                  </ap-field>
                </div>
              </td>
              <td class="col-md-4 pl-0">
                <div class="d-flex part-two">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'28'" [type]="'appkit-number'" [format]="''" [disabled]="true"
                    [styleClass]="'number-field w-70 total-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="TotalAGUB" [ngModelOptions]="{standalone: true}" [placeholder]="'0'"  aria-label="28" />
                  </ap-field>

                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </li>
      </ol>
    </div>
    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
      <tr>
        <td class="header-text">
          <strong>&nbsp;&nbsp;Part VI&nbsp;&nbsp;</strong>
          <strong>Supplemental Statement of Assets Transferred</strong>
        </td>
      </tr>
      </tbody>
    </table>
    <div formGroupName="partSix" class="section-content ap-form-field-my-wrapper">
      <ol class="section-content list-content" start="10">
        <li style="counter-reset: count 9;">
          <div class="d-flex">
            <div class="col-md-8">
              Enter the tax year and tax return form number with the original Form 8023 or Form 8883 and any
              supplemental statements that were filed.
            </div>
            <div class="col-md-2 d-flex">
              <span class="mr-2">Year</span>
              <ap-field [title]="''" [fieldId]="'29'" [styleClass]="'text-box'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="TaxYear" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="29" />
              </ap-field>
            </div>
            <div class="col-md-2 d-flex">
              <span class="mr-2">Form</span>
              <ap-field [title]="''" [fieldId]="'30'" [styleClass]="'text-box'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="TaxReturnFormNumber" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="30" />
              </ap-field>
            </div>
          </div>
        </li>
        <li style="counter-reset: count 10;">
          <table class="table-layout">
            <thead>
            <tr>
              <td class="col-md-3">
                Assets
              </td>
              <td class="col-md-3">
                Allocation of sales price as previously reported<br/>(For e-filing purposes, must be in USD)
              </td>
              <td class="col-md-3">
                Increase or (decrease)<br/>
                (For e-filing purposes, must be in USD)
              </td>
              <td class="col-md-3">
                Redetermination of allocation of AGUB or ADSP<br/>
                (For e-filing purposes, must be in USD)
              </td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="col-md-3 row-label">
                Class I
              </td>
              <td class="col-md-3">
                <div class="d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'31'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class1ASPPR" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 1)"  aria-label="31" />
                  </ap-field>
                </div>
              </td>
              <td class="col-md-3">
                <div class="d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'32'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class1IncDec" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 13)"  aria-label="32" />
                  </ap-field>
                </div>
              </td>
              <td class="col-md-3">
                <div class="d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'33'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class1RtnAllAGUB" [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="updateValue2({value: $event}, 7)" [placeholder]="''"  aria-label="33" />
                  </ap-field>
                </div>

              </td>
            </tr>
            <tr>
              <td class="col-md-3 row-label">
                Class II
              </td>
              <td class="col-md-3">
                <div class="d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'34'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class2ASPPR" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 2)"  aria-label="34" />
                  </ap-field>
                </div>
              </td>
              <td class="col-md-3">
                <div class="d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'35'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class2IncDec" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 14)"  aria-label="35" />
                  </ap-field>
                </div>
              </td>
              <td class="col-md-3">
                <div class="d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'36'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class2RtnAllAGUB" [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="updateValue2({value: $event}, 8)" [placeholder]="''"  aria-label="36" />
                  </ap-field>
                </div>

              </td>
            </tr>
            <tr>
              <td class="col-md-3 row-label">
                Class III
              </td>
              <td class="col-md-3">
                <div class="d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'37'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class3ASPPR" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 3)"  aria-label="37" />
                  </ap-field>
                </div>
              </td>
              <td class="col-md-3">
                <div class="d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'38'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class3IncDec" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 15)"  aria-label="38" />
                  </ap-field>
                </div>
              </td>
              <td class="col-md-3">
                <div class="d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'39'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class3RtnAllAGUB" [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="updateValue2({value: $event}, 9)" [placeholder]="''"  aria-label="39" />
                  </ap-field>
                </div>

              </td>
            </tr>
            <tr>
              <td class="col-md-3 row-label">
                Class IV
              </td>
              <td class="col-md-3">
                <div class="d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'40'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class4ASPPR" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 4)"  aria-label="40" />
                  </ap-field>
                </div>
              </td>
              <td class="col-md-3">
                <div class="d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'41'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class4IncDec" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 16)"  aria-label="41" />
                  </ap-field>
                </div>
              </td>
              <td class="col-md-3">
                <div class="d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'42'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class4RtnAllAGUB" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 10)"  aria-label="42" />
                  </ap-field>
                </div>

              </td>
            </tr>
            <tr>
              <td class="col-md-3 row-label">
                Class V
              </td>
              <td class="col-md-3">
                <div class="d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'43'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class5ASPPR" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 5)"  aria-label="43" />
                  </ap-field>
                </div>
              </td>
              <td class="col-md-3">
                <div class="d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'44'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class5IncDec" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 17)"  aria-label="44" />
                  </ap-field>
                </div>
              </td>
              <td class="col-md-3">
                <div class="d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'45'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class5RtnAllAGUB" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 11)"  aria-label="45" />
                  </ap-field>
                </div>

              </td>
            </tr>
            <tr>
              <td class="col-md-3 row-label">
                Class VI and VII
              </td>
              <td class="col-md-3">
                <div class="d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'46'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class6N7ASPPR" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 6)"  aria-label="46" />
                  </ap-field>
                </div>
              </td>
              <td class="col-md-3">
                <div class="d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'47'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class6N7IncDec" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 18)"  aria-label="47" />
                  </ap-field>
                </div>
              </td>
              <td class="col-md-3">
                <div class="d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'48'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="Class6N7RtnAllAGUB" [ngModelOptions]="{standalone: true}"
                      [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 12)"  aria-label="48" />
                  </ap-field>
                </div>

              </td>
            </tr>
            <tr>
              <td class="col-md-3 row-label">
                Total
              </td>
              <td class="col-md-3">
                <div class="d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'49'" [type]="'appkit-number'" [format]="''" [disabled]="true"
                    [styleClass]="'number-field total-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="TotalASPPR" [ngModelOptions]="{standalone: true}" [placeholder]="'0'"  aria-label="49" />
                  </ap-field>
                </div>
              </td>
              <td class="col-md-3">

              </td>
              <td class="col-md-3">
                <div class="d-flex part-two part-two--fixed-number-field">
                  <span class="currency-prefix">$</span>
                  <ap-field [title]="''" [fieldId]="'50'" [type]="'appkit-number'" [format]="''" [disabled]="true"
                    [styleClass]="'number-field total-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="TotalRtnAllAGUB" [ngModelOptions]="{standalone: true}" [placeholder]="'0'"  aria-label="50" />
                  </ap-field>

                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </li>
        <li style="counter-reset: count 11;">
          <span>Reason(s) for increase or decrease:</span>
          <ap-field [title]="''" [fieldId]="'51'" [styleClass]="'text-box'" [hideTitleOnInput]="true">
                    <textarea appkit-field [(ngModel)]="RsnForIncOrDec" [ngModelOptions]="{standalone: true}" aria-label="51"></textarea>
          </ap-field>
        </li>
      </ol>
      <div class="leid-list d-flex" style="margin-top: 15px;">
        <span>LEIDs: </span>
        <div>
          @if (transferor) {
<span class="template-color-blue">{{ transferor.LEID }}</span>
}@if (transferee) {
<span> /
          </span>
}@if (transferee) {
<span class="template-color-blue">{{ transferee.LEID }}</span>
}
        </div>
      </div>
    </div>
  </div>
</div>
